import { useQuery } from '@tanstack/react-query';

import { sdk } from '@/services';

const CourseService = sdk.getService('CourseService');

export const useAllCoursesWithSectionsByTags = (tags?: string[]) => {
  const { isLoading, data, error } = useQuery({
    queryKey: ['courses', 'with-sections', 'by-tag', tags],
    queryFn: () => CourseService.findAllCoursesWithSectionsByTagForSelectors(tags!),
    enabled: !!tags?.length
  });
  return {
    courses: data,
    isLoading,
    error
  };
};
